(() => {
  const storageKey = 'zovqo_whatsapp_attribution_v1';
  const lifetime = 30 * 60 * 1000;
  const fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'utm_placement', 'placement', 'campaign_id', 'adset_id', 'ad_id', 'ttclid', 'fbclid', 'gclid'];
  const labels = [['utm_medium', 'Medium'], ['utm_campaign', 'Campaign'], ['utm_content', 'Ad / creative'], ['utm_placement', 'Placement'], ['placement', 'Placement'], ['utm_id', 'Campaign ID'], ['campaign_id', 'Campaign ID'], ['adset_id', 'Ad set ID'], ['ad_id', 'Ad ID']];
  const params = new URLSearchParams(location.search);
  const incoming = {};
  fields.forEach((key) => {
    const value = params.get(key);
    if (value && !value.includes('{{') && !value.includes('}}')) incoming[key] = value.slice(0, 2048);
  });
  let attribution;
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey));
    if (saved && Date.now() - saved.timestamp < lifetime) attribution = saved;
  } catch {}
  if (Object.keys(incoming).length) {
    attribution = { timestamp: Date.now(), params: incoming };
    try { sessionStorage.setItem(storageKey, JSON.stringify(attribution)); } catch {}
  }
  const tracked = attribution?.params || {};
  const sourceName = () => {
    const source = tracked.utm_source?.toLowerCase();
    if (source) {
      if (['ig', 'instagram'].includes(source)) return 'Instagram';
      if (['fb', 'facebook'].includes(source)) return 'Facebook';
      if (['tiktok', 'tik_tok', 'tt'].includes(source)) return 'TikTok';
      if (['meta', 'facebook_instagram'].includes(source)) return 'Meta (Facebook/Instagram)';
      return tracked.utm_source;
    }
    if (tracked.ttclid) return 'TikTok (click ID)';
    if (tracked.fbclid) return 'Meta (Facebook/Instagram click ID)';
    if (tracked.gclid) return 'Google Ads (click ID)';
    try {
      const host = new URL(document.referrer).hostname;
      if (host === location.hostname || host.endsWith('.myshopify.com')) return 'Not tagged';
      if (/(^|\.)instagram\.com$/.test(host)) return 'Instagram (referral)';
      if (/(^|\.)tiktok\.com$/.test(host)) return 'TikTok (referral)';
      if (/(^|\.)(facebook\.com|fb\.com)$/.test(host)) return 'Facebook (referral)';
      return `Referral: ${host}`;
    } catch { return 'Not tagged'; }
  };
  const updateLink = (link) => {
    const productUrl = new URL(link.dataset.whatsappUrl || location.href);
    const variant = new URLSearchParams(location.search).get('variant');
    if (variant && /^\d+$/.test(variant)) productUrl.searchParams.set('variant', variant);
    fields.forEach((key) => {
      if (tracked[key]) productUrl.searchParams.set(key, tracked[key]);
    });
    const lines = [
      'Hi, I am interested in buying:',
      link.dataset.whatsappProduct || document.title,
      productUrl.toString(),
      '',
      `Source: ${sourceName()}`
    ];
    const seen = new Set();
    labels.forEach(([key, label]) => {
      if (tracked[key] && !seen.has(label)) {
        lines.push(`${label}: ${tracked[key]}`);
        seen.add(label);
      }
    });
    link.href = `https://wa.me/${link.dataset.whatsappPhone}?text=${encodeURIComponent(lines.join('\n'))}`;
  };
  document.querySelectorAll('[data-whatsapp-phone]').forEach(updateLink);
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-whatsapp-phone]');
    if (link) updateLink(link);
  }, true);
})();
